import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;
const SUPERPARTNER_CONTROLLER_ENDPOINT = `${REACT_APP_REST_ENDPOINT}/superpartner`;


export default class SuperpartnerService {

  // La tua funzione originale, mantenuta
  static getAllSuperpartner = () => {
    const url = `${SUPERPARTNER_CONTROLLER_ENDPOINT}`;
    return ApiService.getRudeRequest(url);
  };

  // --- NUOVI METODI (Simili a quelli di AgenzieService.js) ---

  /*
  static getSuperpartnerByParams = (params) => {
    return new Promise((resolve, reject) => {
        const url = `${SUPERPARTNER_CONTROLLER_ENDPOINT}/find`;
        ApiService.postRudeRequest(resolve, reject, url, params);
    });
  };  
*/
  static getSuperpartnerByParams = (params) => {
        const url = `${SUPERPARTNER_CONTROLLER_ENDPOINT}/find`;
        const token = localStorage.getItem("token"); // Assumiamo che la rotta sia protetta

        // Usiamo fetch direttamente per avere il controllo completo
        return fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(params)
        });
        // NOTA: Non usiamo .then() né new Promise. Restituiamo direttamente la Promise generata da fetch.
        // Sarà l'hook 'useSuperpartner' a gestire la risoluzione della Promise.
    };

  static createSuperpartner = (data) => {
    return new Promise((resolve, reject) => {
        const url = `${SUPERPARTNER_CONTROLLER_ENDPOINT}/create`;
        ApiService.postRequest(resolve, reject, url, data);
    });
  };

  static updateSuperpartner = (data) => {
    return new Promise((resolve, reject) => {
        const url = `${SUPERPARTNER_CONTROLLER_ENDPOINT}/update`;
        ApiService.putRequest(resolve, reject, url, data);
    });
  };

  static deleteSuperpartner = (data) => {
    return new Promise((resolve, reject) => {
        const url = `${SUPERPARTNER_CONTROLLER_ENDPOINT}/delete`;
        ApiService.delete(resolve, reject, url, data);
    });
  };
}